import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pageTitle as getPageTitle } from '../adminNavigation';
import AdminActionBell from './AdminActionBell';

const Header: React.FC = () => {
  const { adminName, logout, logoutError } = useAuth();
  const location = useLocation();

  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="fixed top-0 left-[240px] right-0 z-30 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm">
      <div className="flex items-center justify-between h-16 px-8">
        {/* Left: Page Title */}
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-bold text-gray-800 tracking-tight">
            {pageTitle}
          </h2>
        </div>

        {/* Right: Admin Info + Logout */}
        <div className="flex items-center gap-4">
          <AdminActionBell />
          {/* Admin name chip */}
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/5 border border-primary/10">
            <div className="w-7 h-7 rounded-full bg-primary flex items-center justify-center">
              <span className="text-white text-xs font-bold">
                {adminName.charAt(0).toUpperCase()}
              </span>
            </div>
            <span className="text-sm font-medium text-gray-700">
              {adminName}
            </span>
          </div>

          {/* Logout button */}
          {logoutError && <p role="alert" className="max-w-xs text-xs text-coral">{logoutError}</p>}
          <button
            onClick={logout}
            id="logout-button"
            className="
              flex items-center gap-2 px-4 py-2 rounded-lg
              text-coral text-sm font-semibold
              bg-coral/5 border border-coral/15
              hover:bg-coral/10 hover:border-coral/30
              transition-all duration-200
              active:scale-95
            "
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
